import {
  useQuantzData,
  QuantzProperty,
  QuantzOperation,
  QuantzQueryCacheDuration,
} from '@hotjar/quantz';
import type { QuantzCategoryDataItem } from '@hotjar/quantz';
import { DATE_RANGE_TYPE, DATE_UNITS } from '@hotjar/global-filters';

export const TOP_PAGES_LIMIT = {
  HUNDRED: 100,
  THREE: 3,
};
const DAYS_AMOUNT = 30;

export interface TopPage {
  pageUrl: string;
  sessionCount: number;
}

type PagesLimit = typeof TOP_PAGES_LIMIT.HUNDRED | typeof TOP_PAGES_LIMIT.THREE;

export function useGetTopPages(
  siteId: number,
  limit: PagesLimit = TOP_PAGES_LIMIT.HUNDRED,
): TopPage[] | null {
  const { data } = useQuantzData(
    {
      sessionFilters: {
        dateRange: {
          type: DATE_RANGE_TYPE.RELATIVE,
          amount: DAYS_AMOUNT,
          unit: DATE_UNITS.DAYS,
        },
        filterList: [],
      },
      siteId,
      operation: QuantzOperation.COUNT,
      groupBy: QuantzProperty.PAGE_URL,
      limit,
    },
    true,
    QuantzQueryCacheDuration.Mid,
  );

  if (data?.data?.resultSeries != null && data.data.resultSeries[0].values.length > 0) {
    const results: QuantzCategoryDataItem[] = data.data.resultSeries[0]
      .values as QuantzCategoryDataItem[];

    return results.map(({ category, value }) => ({
      pageUrl: category,
      sessionCount: value,
    }));
  }

  return null;
}
